"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _colors = _interopRequireDefault(require("../../styles/colors"));
var _HBLoader = require("../HBLoader/HBLoader.styles");
var _HBNewTable = require("./HBNewTable.styles");
var _HBNewTable2 = require("./HBNewTable.types");
var _HBNewTableRow = _interopRequireDefault(require("./HBNewTableRow"));
var _HBNewTableInfiniteScroll = _interopRequireDefault(require("./HBNewTableInfiniteScroll"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var HBNewTableRowList = function HBNewTableRowList(_ref) {
  var _selectableProps$sele;
  var items = _ref.items,
    getItemId = _ref.getItemId,
    columnDefinitions = _ref.columnDefinitions,
    selectableProps = _ref.selectableProps,
    infiniteScrollProps = _ref.infiniteScrollProps,
    expandableProps = _ref.expandableProps,
    hasSpacer = _ref.hasSpacer;
  var _useState = (0, _react.useState)(),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    hoveredRowItemId = _useState2[0],
    setHoveredRowItemId = _useState2[1];
  var isSelectable = !!selectableProps;
  var isSelectableMode = (selectableProps === null || selectableProps === void 0 || (_selectableProps$sele = selectableProps.selectedItemIds) === null || _selectableProps$sele === void 0 ? void 0 : _selectableProps$sele.length) > 0;
  var itemsMap = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, items.map(function (item) {
    var itemId = getItemId(item);
    return /*#__PURE__*/_react["default"].createElement(_HBNewTableRow["default"], {
      key: itemId,
      item: item,
      columnDefinitions: columnDefinitions,
      itemId: itemId,
      isSelectable: isSelectable,
      isSelectableMode: isSelectableMode,
      expandableProps: expandableProps,
      hasSpacer: hasSpacer,
      isRowHovered: itemId === hoveredRowItemId,
      setHoveredRowItemId: setHoveredRowItemId
    });
  }));
  var isWithInfi = !!infiniteScrollProps;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, isWithInfi ? /*#__PURE__*/_react["default"].createElement(_HBNewTableInfiniteScroll["default"], {
    element: _HBNewTable.NewTableStyledTbody,
    hasMore: infiniteScrollProps.hasMore,
    loadMore: infiniteScrollProps.loadMore,
    threshold: infiniteScrollProps.threshold || _HBNewTable2.INFINITE_SCROLL_THRESHOLD,
    pageStart: infiniteScrollProps.pageStart,
    columnCount: columnDefinitions.length,
    loader: infiniteScrollProps.loader || /*#__PURE__*/_react["default"].createElement(_HBNewTable.NewTableLoaderContainer, null, /*#__PURE__*/_react["default"].createElement(_HBLoader.Loader, {
      size: "medium",
      color: _colors["default"].blue20
    }))
  }, itemsMap) : /*#__PURE__*/_react["default"].createElement(_HBNewTable.NewTableStyledTbody, null, itemsMap));
};
var _default = exports["default"] = /*#__PURE__*/_react["default"].memo(HBNewTableRowList);
//# sourceMappingURL=HBNewTableRowList.js.map